import { formatRub } from '../../features/genplan/lib/formatPlotValue';

export const purchaseTerms = {
  booking: {
    freeDays: 7,
    paidMaxMonths: 2,
    paidAmountRub: 200_000,
  },
  installment: {
    maxYears: 2,
    rateFromPercent: 6,
  },
} as const;

export const purchaseData = {
  eyebrow: 'Покупка',
  title: 'Как купить участок',
  lead: 'Сделка проходит напрямую с застройщиком. Мы поможем выбрать участок и подготовить необходимые документы.',
  steps: [
    {
      number: '01',
      title: 'Выберите участок',
      description: 'Найдите подходящий вариант на интерактивном генплане.',
      link: {
        label: 'Выбрать на генплане',
        href: '#genplan',
      },
    },
    {
      number: '02',
      title: 'Забронируйте',
      description: `Бесплатная бронь действует семь дней. Участок также можно забронировать на срок до двух месяцев за ${formatRub(purchaseTerms.booking.paidAmountRub)}.`,
    },
    {
      number: '03',
      title: 'Подпишите договор',
      description:
        'После проверки документов стороны подписывают договор купли-продажи. При полной оплате расчёт проводится через аккредитив.',
    },
    {
      number: '04',
      title: 'Зарегистрируйте право собственности',
      description:
        'Документы передаются на государственную регистрацию. После её завершения покупатель становится собственником участка.',
    },
  ],
  payment: {
    eyebrow: 'Способы оплаты',
    title: 'Удобные способы расчёта',
    options: [
      {
        number: '01',
        title: 'Полная оплата',
        description: 'Расчёт через аккредитив.',
      },
      {
        number: '02',
        title: 'Рассрочка',
        facts: [
          `До ${purchaseTerms.installment.maxYears} лет`,
          `От ${purchaseTerms.installment.rateFromPercent}% годовых`,
        ],
        description:
          'До двух лет по ставке от 6% годовых. Первоначальный взнос и график платежей согласовываются индивидуально.',
      },
      {
        number: '03',
        title: 'Ипотека',
        description:
          'Возможна покупка участка либо участка вместе со строительством дома — в зависимости от условий выбранной банковской программы.',
      },
    ],
    note: `При покупке сумма платной брони засчитывается в стоимость участка. При отказе покупателя от сделки она не возвращается. Точные условия фиксируются в соглашении о бронировании.`,
  },
} as const;
